<template>
  <div class="fs-table-container">
    <table class="fs-table">
      <thead>
        <tr>
          <th class="column-header">日期</th> <!-- 添加日期表头 -->
          <th v-for="(item, index) in windData" :key="`time-${index}`">{{ item.time }}</th>
        </tr>
      </thead>
      <tbody>
        <!-- 风力行 -->
        <tr>
          <td class="row-header">风力</td>
          <td v-for="(item, index) in windData" :key="`force-${index}`">{{ item.force }}</td>
        </tr>
        <!-- 风向行 -->
        <tr>
          <td class="row-header">风向</td>
          <td v-for="(item, index) in windData" :key="`direction-${index}`">{{ item.direction }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps, computed } from "vue";

const props = defineProps({
  listData: {
    type: Array,
    default: () => [],
  },
});

// 计算属性：将传入的数据转换为表格所需的结构
const windData = computed(() => {
  // listData现在应该是一个包含完整风速数据的数组
  // 每个元素应该有time、force、direction等属性
  return props.listData || [];
});
</script>

<style scoped>
.fs-table-container {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fs-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  min-height: 350px; /* 稍微增加表格最小高度 */
}

.fs-table th {
  background-color: rgba(9, 39, 44, 0.8);
  color: #fff;
  font-size: 28px;
  padding: 30px 20px; /* 稍微增加垂直内边距 */
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-weight: bold;
  white-space: nowrap;
  min-width: 120px;
  height: 90px; /* 稍微增加固定高度 */
  vertical-align: middle;
}

.fs-table td {
  color: #fff;
  font-size: 26px;
  padding: 40px 20px; /* 稍微增加垂直内边距 */
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-color: rgba(7, 19, 21, 0.5);
  white-space: nowrap;
  height: 110px; /* 稍微增加固定高度 */
  vertical-align: middle;
}

/* 列标题样式 - 日期表头 */
.fs-table .column-header {
  background-color: rgba(9, 39, 44, 0.9);
  color: #fff;
  font-weight: bold;
  text-align: right;
  padding: 30px 30px;
  min-width: 100px;
  font-size: 28px;
}

/* 行标题样式 */
.fs-table .row-header {
  background-color: rgba(9, 39, 44, 0.8);
  color: #fff;
  font-weight: bold;
  text-align: right;
  padding: 40px 30px; /* 稍微增加垂直内边距 */
  min-width: 100px;
  font-size: 28px;
}

/* 风力行样式 */
.fs-table tr:nth-child(1) td {
  background-color: rgba(7, 19, 21, 0.5);
}

/* 风向行样式 */
.fs-table tr:nth-child(2) td {
  background-color: rgba(9, 39, 44, 0.3);
}

.fs-table tr:hover td {
  background-color: rgba(255, 215, 145, 0.1);
}
</style>
